import { render, staticRenderFns } from "./WidgetMyAccountSidebar.vue?vue&type=template&id=6a03c3a2&scoped=true&"
import script from "./WidgetMyAccountSidebar.vue?vue&type=script&lang=js&"
export * from "./WidgetMyAccountSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a03c3a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a03c3a2')) {
      api.createRecord('6a03c3a2', component.options)
    } else {
      api.reload('6a03c3a2', component.options)
    }
    module.hot.accept("./WidgetMyAccountSidebar.vue?vue&type=template&id=6a03c3a2&scoped=true&", function () {
      api.rerender('6a03c3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/WidgetMyAccountSidebar.vue"
export default component.exports